import { Component, Injector } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmDialogConfig, CrudConfirmDialogComponent, CrudDataSource, CrudDeleteDialogComponent, CrudListComponent, UserStorage } from '@scisys-uim/uim-common';

import { openAsHtmlEmail, TRANSFER_ASSET_TYPE, TransferAsset, TransferAssetApprover } from 'assets-model';
import { PendingTransferAssetApprovalDataSource, TextSectionService, TransferAssetApproverService, TransferAssetService } from 'assets-service';
import moment from 'moment';

@Component({
    selector: 'app-pending-transfer-asset-approve',
    templateUrl: './pending-transfer-asset-approve.component.html',
    styleUrls: ['./pending-transfer-asset-approve.component.scss']
})
export class PendingTransferAssetApproveComponent extends CrudListComponent<TransferAsset, number> {
    displayedColumns: string[] = ['description', 'sourceBusinessUnit.buId', 'sourceCostCentre.ccId', 'targetBusinessUnit.buId', 'targetCostCentre.ccId', 'createdBy', 'dateCreated', 'actions'];

    disabledColumns: string[] = [];
    validateApproval = false;
    emailTitle: string;
    emailBody: string;

    constructor(protected route: ActivatedRoute,
        protected router: Router,
        protected userStorage: UserStorage,
        protected textSectionService: TextSectionService,
        protected transferAssetApproverService: TransferAssetApproverService,
        protected dialog: MatDialog,
        protected transferAssetService: TransferAssetService,
        protected injector: Injector) {
        super(TRANSFER_ASSET_TYPE, route, router, userStorage, dialog, transferAssetService, injector);
    }

    ngOnInit() {
        super.ngOnInit();

        // if we disable too soon, the column header display text won't be rendered, and the picker will have code names not display names.
        this.columns.$afterViewInit.subscribe(data => {
            this.columns.setColumnsEnabled(this.disabledColumns, false);
            // reset the defaults for the context so the picker Reset button doesn't re-enable the columns above
            this.columns.resetInitialDisplayColumns();
            // delayed wiring until context set, so that we don't start remembering changes too early
            this.restoreColumnState();
            this.rememberColumnState();
        });
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.loadEmailTitleAndBody();
    }

    createDataSource(): CrudDataSource<TransferAsset> {
        return new PendingTransferAssetApprovalDataSource(this.transferAssetService);
    }

    createServiceArguments() {
        return {};
    }


    allowsApproval(element: TransferAsset): boolean {
        return this.userStorage?.currentUserHasAnyAuthority("APPROVE_TRANSFER_ASSET") && !this.currentUserIsCreator(element);
    }

    viewOrEditRouteToTransferAsset(element: TransferAsset): any[] {
        const keySegments = TRANSFER_ASSET_TYPE.entityDecorator.toKeyRouteSegments(element);
        if (!keySegments) {
            return;
        }
        var routeBase = TRANSFER_ASSET_TYPE.viewRouteBase;
        if (this.userStorage?.currentUserHasAnyAuthority(TRANSFER_ASSET_TYPE.editAuthorities)) {
            routeBase = TRANSFER_ASSET_TYPE.editRouteBase;
        }
        return [...routeBase, ...keySegments];
    }

    currentUserIsCreator(element: TransferAsset): boolean {
        return this.userDetails?.username == element?.createdBy;
    }

    deleteWithConfirmation(item: TransferAsset) {
        const self = this;
        var dialogRef: MatDialogRef<CrudConfirmDialogComponent, boolean> = this.openConfirmationDialog(item, {
            data: <ConfirmDialogConfig<TransferAsset, number>>{
                title: 'Delete',
                action: 'Delete',
                component: CrudDeleteDialogComponent
            }
        });
        dialogRef.afterClosed().subscribe((confirm: boolean) => {
            if (confirm) {
                self.transferAssetService.delete(item.transferAssetId).subscribe(() => {
                    self.forceSearch();
                });
            }
        });
    }

    openEmailReminder(element: TransferAsset) {
        const emailBodyAsDom = document.createElement('div');
        emailBodyAsDom.innerHTML = this.emailBody.replace("%{dateCreated}", moment(element.dateCreated).format("D MMMM YYYY")).
            replace("%{userName}", this.userDetails.username)
            .replace("%{assetBu}", element.asset.businessUnit?.buId)
            .replace("%{assetCc}", element.asset.costCentre?.ccId == null ? "" : element.asset.costCentre?.ccId)
            .replace("%{assetName}", element.asset.description);
        var emailBodyHtml = emailBodyAsDom.innerHTML;
        const subject = this.emailTitle.replace("%{assetName}", element.asset.description);

        this.transferAssetApproverService.findByFullFilters({
            buId: element?.businessUnit?.buId,
            composedAssetClass: 'Asset'
        }).subscribe(
            data => {
                const transferAssetApprovers = data.items;
                if (transferAssetApprovers.length > 0) {
                    openAsHtmlEmail(transferAssetApprovers[0].email, "", subject, emailBodyHtml, "Transfer Asset Reminder -" + element.asset.assetId + " - " + element.asset.description);
                }
                else {
                    openAsHtmlEmail("", "", subject, emailBodyHtml, "Transfer Asset Reminder -" + element.asset.assetId + " - " + element.asset.description);
                }
            });
    }

    loadEmailTitleAndBody() {
        this.textSectionService.get('assets.transfer-reminder.title').subscribe(data => {
            this.emailTitle = data.text;
        });
        this.textSectionService.get('assets.transfer-reminder.body').subscribe(data => {
            this.emailBody = data.text;
        });
    }
}



